export function initializeTabstrip() {
    function initTabstrip(root) {
        const tablist = root.querySelector('[role="tablist"]');
        if (!tablist) return;

        const tabs = Array.from(tablist.querySelectorAll(':scope > li.k-item[role="tab"]'));
        const panels = Array.from(root.querySelectorAll('.k-tabstrip-content [role="tabpanel"]'));

        const isDisabled = el =>
            el.classList.contains('k-disabled') || el.getAttribute('aria-disabled') === 'true';

        let activeIndex = tabs.findIndex(t => t.classList.contains('k-active'));
        if (activeIndex < 0) activeIndex = 0;

        tabs.forEach((t, i) => {
            const panel = panels[i];

            t.id ||= `tab-${i}-${uid(root)}`;
            panel.id ||= `panel-${i}-${uid(root)}`;

            t.setAttribute('role', 'tab');
            t.setAttribute('aria-controls', panel.id);
            t.setAttribute('tabindex', i === activeIndex ? '0' : '-1');
            panel.setAttribute('role', 'tabpanel');
            panel.setAttribute('aria-labelledby', t.id);

            t.addEventListener('click', () => {
                if (isDisabled(t)) return;
                activate(i);
                t.focus();
            });
        });

        function activate(i) {
            activeIndex = i;

            tabs.forEach((t, j) => {
                const isActive = i === j;

                t.classList.toggle('k-active', isActive);
                t.setAttribute('aria-selected', String(isActive));
                t.setAttribute('tabindex', isActive ? '0' : '-1');

                const panel = panels[j];
                panel.classList.toggle('k-active', isActive);
                panel.hidden = !isActive;

                const wrapper = panel.closest('.k-animation-container');
                if (wrapper) {
                    wrapper.style.width = isActive ? '' : '0';
                    wrapper.style.height = isActive ? '' : '0';
                }
            });

            tabs.forEach((t, j) => {
                t.classList.toggle('k-first', j === 0);
                t.classList.toggle('k-last', j === tabs.length - 1);
            });
        }

        function uid(scope) {
            return scope.dataset.uid || (scope.dataset.uid = Math.random().toString(36).slice(2));
        }
    }

    document.querySelectorAll('.cwx-tabstrip').forEach(initTabstrip);
}